import axios from "axios";
const BASE_API_URL = process.env.REACT_APP_API_URL;

// here from new api
export const Get_Countries = `${BASE_API_URL}/Country/Country_GetList_Active`;
export const Send_Otp_With_Registration = `${BASE_API_URL}/RamNamBook/SendOtp_WithRegistration`;
export const VerifyOtp_RamNamBook = `${BASE_API_URL}/RamNamBook/VerifyOtp_RamNamBook`;
export const ResendOtp_RamNamBook = `${BASE_API_URL}/RamNamBook/ResendOtp_RamNamBook2`;
// export const Send_Login_Otp = `${BASE_API_URL}/RamNamBook/SendLogin_Otp`;
export const Send_Login_Otp = `${BASE_API_URL}/RamNamBook/SendLogin_Otp2`;
export const Verify_Login_Otp = `${BASE_API_URL}/RamNamBook/VerifyLogin_Otp`;
// -------------------------------------------
export const Get_Member_Total_Summary = `${BASE_API_URL}/Member/GetMemberTotalSummary`;
export const Get_Digital_RamName_Count = `${BASE_API_URL}/DigitalRAMNameTransaction/GetDigitalRamNameCount`;
export const Submit_Digital_Ram_Name = `${BASE_API_URL}/DigitalRAMNameTransaction/SubmitDigitalRamName`;

// --------------------------------------------
export function submitDigitalRamNameApi(
  ramNamBookMemberID,
  totalCount,
  deviceTypeID
) {
  return axios.post(Submit_Digital_Ram_Name, {
    ramNamBookMemberID,
    totalCount,
    deviceTypeID,
  });
}
export function getDigitalRamNameCount(memberId) {
  return axios.get(`${Get_Digital_RamName_Count}?memberId=${memberId}`);
}
export function getMemberTotalSummary(memberId) {
  return axios.get(`${Get_Member_Total_Summary}?memberId=${memberId}`);
}

// ----------------------------------------------------------------
export function sendLoginRamNamOtpApi(mobileNumber) {
  return axios.post(Send_Login_Otp, { mobileNumber });
}
export function verifyLoginRamNamOtpApi(mobileNumber, otp) {
  return axios.post(Verify_Login_Otp, { mobileNumber, otp });
}

export function sendOtpWithRegistrationApi(
  mobileNumber,
  memberName,
  countryID,
  villageCityName,
  pincode,
  addressAndText,
  termsAccepted
) {
  return axios.post(Send_Otp_With_Registration, {
    mobileNumber,
    memberName,
    countryID,
    villageCityName,
    pincode,
    addressAndText,
    termsAccepted,
  });
}
export function verifyRamNamOtpApi(mobileNumber, otp) {
  return axios.post(VerifyOtp_RamNamBook, { mobileNumber, otp });
}

// --------------------------------------------
export function getCountryActiveListApi() {
  return axios.get(Get_Countries);
}
export function resendRamNamBookOtpApi(mobileNumber) {
  return axios.post(ResendOtp_RamNamBook, { mobileNumber });
}

// export function addRamNamBookMemberApi(
//   memberName,
//   mobileNumber,
//   countryID,
//   villageCityName,
//   pincode,
//   addressAndText,
//   termsAccepted
// ) {
//   return axios.post(Add_RamNamBook_Register_Details, {
//     memberName,
//     mobileNumber,
//     countryID,
//     villageCityName,
//     pincode,
//     addressAndText,
//     termsAccepted,
//   });
// }
